import { combineReducers } from 'redux'
import language from '../../../common/reducers/language'
import login from "../../../common/reducers/login"
import modal from "../../../common/reducers/modal"
import search from './search'
import { reducer as formReducer } from 'redux-form'

const rootReducer = combineReducers({
  login,
  language,
  modal,
  form: formReducer,
  apartments: search('apartments'),
  houses: search('houses'),
  relaxed: search('relaxed')
})
export default rootReducer
